import type { Dons } from "../../types/Dons";
import { useTrads } from "../../contexts/trads/useTrads";
import DonsPayementsList from "../DonsPayements/DonsPayementsList";


function DonsItem({don}:{don:Dons}) {
    const {translate}=useTrads();

    return (
        <div className="row">
            <h2>{don.nom} {don.prenom}</h2>
            <dl>
                <dt>{translate('don_id')}</dt><dd>{don.id}</dd>
                <dt>{translate('don_fond_id')}</dt><dd>{don.fond_id}</dd>
                <dt>{translate('don_montant')}</dt><dd>{don.montant} €</dd>
                <dt>{translate('don_support')}</dt><dd>{don.support}</dd>
                <dt>{translate('don_recurent')}</dt><dd>{don.recurent}</dd>
                <dt>{translate('don_subscriptionId')}</dt><dd>{don.subscriptionId}</dd>
                <dt>{translate('don_civ')}</dt><dd>{translate(don.civ)}</dd>
                <dt>{translate('don_raison_soc')}</dt><dd>{don.raison_soc}</dd>
                <dt>{translate('don_email')}</dt><dd>{don.email}</dd>
                <dt>{translate('don_nom')}</dt><dd>{don.nom}</dd>
                <dt>{translate('don_prenom')}</dt><dd>{don.prenom}</dd>
                <dt>{translate('don_adresse')}</dt><dd>{don.adresse}</dd>
                <dt>{translate('don_zip')}</dt><dd>{don.zip}</dd>
                <dt>{translate('don_tel')}</dt><dd>{don.tel}</dd>
                <dt>{translate('don_ville')}</dt><dd>{don.ville}</dd>
                <dt>{translate('don_pays')}</dt><dd>{don.pays}</dd>
                <dt>{translate('don_nature')}</dt><dd>{don.nature}</dd>
                <dt>{translate('don_registre')}</dt><dd>{don.registre}</dd>
                <dt>{translate('don_statut')}</dt><dd>{don.statut}</dd>
                <dt>{translate('don_lang')}</dt><dd>{don.lang}</dd>
                <dt>{translate('don_remarque')}</dt><dd>{don.remarque}</dd>

               
                
            </dl>
            <DonsPayementsList don_id={don.id} />
        </div>
    );
}
export default DonsItem;